export default __webpack_public_path__ + "static/media/kuldeep.57a945cc.JPEG";